import React, { useEffect, useRef } from 'react'
import PropTypes from 'prop-types'
import { useField } from '@unform/core'

function Checkbox({ id, label, name, ...props }) {
  const inputRef = useRef(null);
  const { fieldName, registerField, defaultValue, error } = useField(name);

  useEffect(() => {
    registerField({
      name: fieldName,
      ref: inputRef.current,
      path: 'value'
    })
  }, [fieldName, registerField]);

  return (
    <div className="form-group form-check">
      <input type="checkbox"
        ref={inputRef} id={id}
        className="form-check-input"
        defaultValue={defaultValue} {...props} />
      {label && <label className="form-check-label" htmlFor={id}>{label}</label>}
      {error && <p className="text-danger">{error}</p>}
    </div>
  )
}

Checkbox.propTypes = {
  id: PropTypes.string.isRequired,
  label: PropTypes.string,
  name: PropTypes.string.isRequired
}

export default Checkbox;